export const PLAN_WRITTEN_CONTEXT_KEY = Symbol("planagentPlanWritten");
export const PLAN_PROGRESS_CONTEXT_KEY = Symbol("planagentPlanProgress");
